<template>
  <LmDialog v-model="modalShow" :styles="dialogStyles" title="Assign licenses">
    <template #toolbar-actions>
      <q-btn label="Save" size="sm" color="positive" @click.native="save()" />
    </template>
    <template #content>
      <q-card-section>
        <ag-grid-wrapper
          v-if="gridOptions"
          ref="wrapper"
          :options="gridOptions"
          preselect-rows
          flat-card
          @selectedRows="updateSelected"
        >
          <div slot="footerActions" class="row q-pl-md q-pb-md">
            <div class="column col-xs-12">
              <small class="fake-link text-tertiary" @click.prevent="createLicense()">
                <i data-v-08528802="" class="fas fa-plus q-mr-sm" /> Create a new license
              </small>
            </div>
          </div>
        </ag-grid-wrapper>
        <form-license-period
          :showing="showLicenseModal"
          :license-period="licensePeriod"
          :disable-properties="['publisher_id']"
          @refresh="refresh()"
          @close="closeFormModal()"
        />
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import * as apiTo from '@/modular-api'
import { mapGetters } from 'vuex'
import { dateSorter, entityNameSorter, getProp, periodRenderer } from '@lib/generic.utils'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import FormLicensePeriod from '@components/forms/form-license-period/FormLicensePeriod'
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  name: 'AssignLicenseModal',
  components: {
    AgGridWrapper,
    FormLicensePeriod,
    LmDialog
  },
  props: {
    showing: {
      type: Boolean
    },
    licenses: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      rowData: [],
      selectedLicensePeriods: null,
      showLicenseModal: false,
      gridOptionsTemplate: {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        columnDefs: [
          {
            headerName: 'License',
            field: 'license',
            checkboxSelection: true,
            headerCheckboxSelection: true,
            comparator: entityNameSorter,
            tooltipValueGetter: params => getProp(params.value, 'name', 'N/A'),
            cellRenderer: params => getProp(params.value, 'name', 'N/A')
          },
          {
            headerName: 'Publisher',
            field: 'license.publisher',
            comparator: entityNameSorter,
            tooltipValueGetter: params => getProp(params.value, 'name', 'N/A'),
            cellRenderer: params => getProp(params.value, 'name', 'N/A')
          },
          {
            headerName: 'Period',
            comparator: dateSorter,
            cellRenderer: params => periodRenderer(params.data),
            tooltipValueGetter: params => periodRenderer(params.data)
          }
        ]
      },
      gridOptions: null,
      dialogStyles: { minWidth: '900px', minHeight: '400px' }
    }
  },
  computed: {
    ...mapGetters('subscription-show', ['subscription']),
    licensePeriod() {
      return {
        previous_license_period_id: null,
        license_id: null,
        publisher_id: this.subscription.publisher.id,
        name: null,
        start_date: Date.now(),
        end_date: null,
        summary: null,
        subscriptions: [],
        owner_id: null,
        license_file: null,
        terms: []
      }
    },
    modalShow: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.$emit('close')
      }
    }
  },
  watch: {
    licenses(newVal) {
      let gridOptions = Object.assign({}, this.gridOptionsTemplate)
      gridOptions.rowData = newVal
      this.$set(this, 'gridOptions', gridOptions)
    }
  },
  created() {
    let gridOptions = Object.assign({}, this.gridOptionsTemplate)
    gridOptions.rowData = this.licenses
    this.$set(this, 'gridOptions', gridOptions)
  },
  methods: {
    closeModal() {
      this.$emit('close')
      this.$set(this, 'gridOptions', null)
    },
    updateSelected(selected) {
      this.$set(this, 'selectedLicensePeriods', selected)
    },
    save() {
      apiTo
        .UPDATE_SUBSCRIPTION_LICENSE_PERIODS(this.subscription.id, {
          license_periods: this.selectedLicensePeriods
        })
        .then(() => {
          this.$emit('done')
          this.$set(this, 'gridOptions', null)
        })
    },
    createLicense() {
      this.showLicenseModal = true
    },
    closeFormModal() {
      this.showLicenseModal = false
    },
    refresh() {
      this.closeFormModal()
      this.$emit('refetch')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins.styl'

tableWithCheckBoxes();
</style>
